import { Component, h, Prop } from "@stencil/core";
import { BackToTopProps } from "./f-back-to-top-model";

@Component({
  tag: "f-back-to-top",
  shadow: true,
})
export class BackToTop {
  @Prop() backToTopHiddenLabel: BackToTopProps["backToTopHiddenLabel"] = (
    window as any
  ).translations["bcp-acc"]["back-to-top"];
  @Prop() titleText: BackToTopProps["titleText"] = this.backToTopHiddenLabel;

  backToTop() {
    const scrollToTop = () => {
      const c = document.documentElement.scrollTop || document.body.scrollTop;
      if (c > 0) {
        window.requestAnimationFrame(scrollToTop);
        // the hardcoded number (8) defines the scrolling speed
        window.scrollTo(0, c > 2 ? c - c / 8 : 0);
      }
    };
    scrollToTop();
  }

  render() {
    return (
      <f-button variant="integrated" onClick={() => this.backToTop()}>
        <f-visually-hidden>{this.backToTopHiddenLabel}</f-visually-hidden>
        <f-icon iconName="up" titleText={this.titleText}></f-icon>
        <slot />
      </f-button>
    );
  }
}
